import { AddressDto, PersonTypeEnum, NaturalPersonDto, LegalEntityDto } from "api/actor";
import { BrokerDto, GetLeadBrokerListItemDto } from "api/broker";

export interface BaseSearchResult {
  id: string;
  name: string;
  personType: PersonTypeEnum;
}

export interface SearchPersonResult extends BaseSearchResult {
  civility?: string,
  phone: string,
  /** Renseigné selon la source (ex. courtiers) — sert de sous-titre dans les résultats. */
  email?: string,
  address?: AddressDto | null,
  registrationNumber?: string,
  data: NaturalPersonDto | LegalEntityDto | BrokerDto
}

export interface SearchLeadBrokerResult extends BaseSearchResult {
  email?: string;
  phone?: string;
  branchCodes?: string[];
  pendingQuotesCount?: number;
  data: GetLeadBrokerListItemDto;
}

export enum SearchFeatureFilter {
  Default,
  Broker,
  LeadBroker,
}

export interface ExcludeFilter<T extends BaseSearchResult> {
  field: keyof T;
  values: (string | number | boolean)[];
}

export interface UseSearchPersonParams<T extends BaseSearchResult> {
  withNaturalPerson?: boolean;
  withLegalEntity?: boolean;
  onSelect: (item: T | null) => void;
  featureFilter?: SearchFeatureFilter;
  excludeFilter?: ExcludeFilter<T>;
  /**
   * Filtre les personnes par plateforme (mode admin du wizard contrat collectif).
   * Quand renseigné, remplace côté back le scope par courtier connecté.
   */
  plateformeId?: string;
}

export interface UseSearchPersonReturn<T extends BaseSearchResult> {
  searchResults: T[];
  searchText: string;
  isLoading: boolean;
  isOpen: boolean;
  totalCount: number;
  selectedItem: T | null;
  handleOpen: () => void;
  handleSearchChange: (value: string) => void;
  handleClose: () => void;
  handleSelectItem: (item: T | null) => void;
}
